module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAALGPC/xhBQAAAQBJREFUWAntmCEOwlAQROf/YEhIDQkWxQGwOC7AJSo4AyfgDIheggvgsBwAVdsE05AU03wYyJgmK2krdkQ3f36Tnb6t2tC82lTVwOkScCuBxzOgT81nCeslsN8mLDIglFWb8iKgbvoN0v3obJpQ5AkTkmGYzQo47PBN2X35n2dO53gGrvfwmRIQOSZqiDDsyzGxN8UsUf8ML4aSejNLHCqE1dcDWWTkOyGRsKoTssjId0IiYVUnZJGR74REwqpOyCIj3wmJhFWdkEVGvhMSCas6IYuMfCckElZ1QhYZ+ZH7GYpbiKGk3swSuSyiuBLRxc/p56l1DLsxy+gWVmFsK703qENQRw/pcfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/all_icon_checkbox_default@2x.png
// module id = S+0V
// module chunks = 1